/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Agent_PasskeysInputs */



/**
* | output |
* | --- |
* | "AI agent passkeys" |
*
* @param {Profile_Security_Agent_PasskeysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkeys = /** @type {((inputs?: Profile_Security_Agent_PasskeysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_PasskeysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkeys der KI-Agenten")
	return /** @type {LocalizedString} */ ("AI agent passkeys")
});